import React from 'react';

import Checkbox from 'material-ui/Checkbox';
import Divider from 'material-ui/Divider';
import { ListItem } from 'material-ui/List';

import moment from 'moment';

import MarkerText from '../../../components/MarkerText';

function AssignmentListItem(props) {
  const { onProgressChange, onItemSelected, item } = props;

  // The ListItem use of `primaryTogglesNestedList` and Checkbox function
  // is to allow the user to click the checkbox without triggering the ListItem's
  // onClick and vice versa. Taken from https://github.com/mui-org/material-ui/issues/1357#issuecomment-325355245
  return (
    <div>
      <ListItem 
        value={item.id}
        onClick={() => onItemSelected(item)}
        primaryTogglesNestedList={true}
        leftCheckbox={(
          <Checkbox
            checked={item.get('completed') === 1}
            onClick={(e) => { e.stopPropagation(); onProgressChange(e, item); }}
            style={{width: 'auto'}} /> 
        )} >
        
        <div className="list-content__list__item">
          <div className="list-content__list__item__text">
            <p className="list-content__list__item__text-title">
              {item.get('title')}
            </p>
            <p className="list-content__list__item__text-subtitle">
              {item.get('text')}
            </p>
          </div>
          <div className="list-content__list__item__detail">
            <p className="list-content__list__item__detail-title">
              {moment(item.get('dueAt')).format('ddd, l')}
            </p>
            {item.get('course') != null ? (
              <MarkerText 
                className='list-content__list__item__detail-subtitle' 
                markerStyle={{height: '6px', width: '6px', marginBottom: '2px', marginRight: '4px'}}
                text={item.get('course').get('title')} 
                color={item.get('course').get('color')} />
              ) : null}
          </div>
        </div>
      </ListItem>
      <Divider />
    </div>
  )
}

export default AssignmentListItem;


// WEBPACK FOOTER //
// ./src/scenes/Assignments/components/AssignmentListItem.js